import { useToken } from 'app/hooks'
import moment from 'moment'
import React, { useEffect } from 'react'
import useSWR from 'swr'
import API from 'utils/api'
import TableAPI from '../TableAPI'
import { column_log_page } from '../AdminUserModal/UserInfoTabs/column_log_page'

const ActiveLog = ({ userid, date }) => {
	//date 앞뒤로 10초 yyyy-mm-dd hh:mm:ss
	const [apikey, setApikey] = React.useState<any>(null)

	useEffect(() => {
		try {
			let startdate = moment(date)
				.add(9, 'hours')
				.subtract(10, 'seconds')
				.format('YYYY-MM-DD HH:mm:ss')
			let enddate = moment(date)
				.add(9, 'hours')
				.add(10, 'seconds')
				.format('YYYY-MM-DD HH:mm:ss')

			//%20 없애기
			let key = `/admin/history/users?log=&type=user_id&searchWord=${userid}&startdate=${startdate}&enddate=${enddate}&t=`

			setApikey(key)
		} catch (e) {
			console.error('@ActiveLog', e)
		}
	}, [date])

	return (
		<TableAPI
			title="활동로그"
			columns={column_log_page}
			datesearch={false}
			defaultMaxData={10}
			usermodal={false}
			height={'default'}
			apikey={apikey}
		/>
	)
}

export default React.memo(ActiveLog)
